import { useState, useEffect } from 'react';
import { getProfile } from './api';

export const useUserProfile = () => {
  const [firstname, setFirstname] = useState(null);
  const [lastname, setLastName] = useState(null);
  const [email, setEmail] = useState(null);

  const obtainProfile = async () => {
    try {
        const userProfile = await getProfile();
        setFirstname(userProfile.first_name);
        setLastName(userProfile.last_name);
        setEmail(userProfile.email);
    } catch (error) {
        console.log(error);
    }
  }

  const refreshProfile = () => {
    obtainProfile()
  }

  useEffect(() => {
    obtainProfile();
  }, [])

  return {
    firstname, 
    lastname,
    email,
    refreshProfile
  };
};